export const AI_DYNAMIC_TOKEN_INSERT = 'EmailAIDynamicText:insert';
export const AI_DYNAMIC_TOKEN = 'AI_DYNAMIC_TOKEN';